import text from './text';
import placeholderIMG from '../../images/source.png';

export const story = {
    slug: 'drift',
    title: 'Drift',
    interactive: 'drift',
    img: placeholderIMG,
    year: 'pulled into stillness',
    tags: ['contemplative'],
    md: text,
}
